import http from '@/utils/http'
import Utils from '@/utils/default'

const fetchAll = ({ page = 1 }) => http()
  .get(`/payouts?${Utils.dataToUrlString({ page })}`)

export default {
  fetchAll
}



// WEBPACK FOOTER //
// ./src/api/transfer.js